import { render } from "./SchedulesManager.vue?vue&type=template&id=5c4f2dce"
import script from "./SchedulesManager.vue?vue&type=script&lang=js"
export * from "./SchedulesManager.vue?vue&type=script&lang=js"

import "./SchedulesManager.vue?vue&type=style&index=0&id=5c4f2dce&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__